<template>
    <div class="registerPage">
        <!-- 注册 -->
        <div class="reg_box">
            <div class="exit" @click="exit">返回登录</div>
            <div class="reg_Title">
                <div class="logo"></div>
                <div class="con">账号注册</div>
            </div>
            <el-form ref="form" :model="form" :rules="rules" label-position="top">
                <el-form-item prop="phone" label="手机号">
                    <el-input v-model="form.phone" placeholder="手机号"></el-input>
                </el-form-item>
                <el-form-item prop="code" label="验证码">
                    <div class="code_la">
                        <el-input v-model="form.code" style="width: 370px" placeholder="验证码"></el-input><el-button
                            disabled>获取验证码</el-button>
                    </div>
                </el-form-item>
                <el-form-item prop="phone2" label="账号">
                    <el-input v-model="form.phone" placeholder="请输入账号"></el-input>
                </el-form-item>
                <el-form-item prop="phone3" label="密码">
                    <el-input v-model="form.phone" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item prop="phone4" label="确认密码">
                    <el-input v-model="form.phone" placeholder="请确认密码"></el-input>
                </el-form-item>
                <el-form-item prop="phone5" label="姓名">
                    <el-input v-model="form.phone" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item prop="phone6" label="单位">
                    <el-input v-model="form.phone" placeholder="请输入单位"></el-input>
                </el-form-item>
                <el-form-item prop="phone7" label="单位邮箱">
                    <el-input v-model="form.phone" placeholder="请输入单位邮箱"></el-input>
                </el-form-item>
            </el-form>
            <div class="submit_btn">
                <div class="btn" @click="submitForm('form')">
                    注册
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                phone: '',
                code: '',
                phone2: '',
                phone3: '',
                phone4: '',
                phone5: '',
                phone6: '',
                phone7: '',
            },
            rules: {
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ],
                phone2: [
                    { required: true, message: '请输入账号', trigger: 'blur' },
                ],
                phone3: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                ],
                phone4: [
                    { required: true, message: '请确认密码', trigger: 'blur' },
                ],
                phone5: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                ],
                phone6: [
                    { required: true, message: '请输入单位', trigger: 'blur' },
                ],
                phone7: [
                    { required: true, message: '请输入单位邮箱', trigger: 'blur' },
                ],
            }
        }
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    alert('submit!');
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        exit() {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="scss" scoped>
.registerPage {
    background: #EAEEF0;
    display: flex;
    justify-content: center;

    .reg_box {
        padding: 20px;
        margin: 80px 0;
        width: 500px;
        background: #FFFFFF;
        border-radius: 14px;
        position: relative;

        .exit {
            position: absolute;
            right: 20px;
            top: 20px;
            cursor: pointer;
            font-family: AlibabaPuHuiTiR;
            font-size: 12px;
            color: #094990;
        }

        .reg_Title {
            display: flex;
            align-items: center;

            .logo {
                width: 130px;
                height: 54%;
            }

            .con {
                font-family: AlibabaPuHuiTiM;
                font-size: 16px;
                color: #333333;
                border-left: 1px solid #E2E6ED;
                padding-left: 20px;
            }
        }

        .code_la {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .submit_btn {
            display: flex;
            justify-content: center;

            .btn {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 500px;
                height: 31px;
                background: #094990;
                border-radius: 3px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                color: #FFFFFF;
                letter-spacing: 8px;
                cursor: pointer;
            }
        }
    }
}
</style>